<template>
  <SubpageShell
    :eyebrow="trans.get('landing.subpages.impressum.eyebrow')"
    :title-prefix="trans.get('landing.subpages.impressum.title_prefix')"
    :title-grad="trans.get('landing.subpages.impressum.title_grad')"
    :title-suffix="trans.get('landing.subpages.impressum.title_suffix')"
    :lede-prefix="trans.get('landing.subpages.impressum.lede')"
    :show-jugendschutz="true"
    :show-cta="false"
    footer-variant="legal"
  >
    <main class="prose">
      <h2>{{ trans.get('landing.subpages.impressum.prose.h2_provider') }}</h2>
      <p>viluu.de wird betrieben von der</p>
      <p>
        <strong>We2Gether GmbH</strong><br />
        Friedrichstraße 171<br />
        10117 Berlin<br />
        Deutschland
      </p>

      <h2>{{ trans.get('landing.subpages.impressum.prose.h2_represented_by') }}</h2>
      <p>Geschäftsführerin: Lena-Marie Neumann</p>

      <h2>{{ trans.get('landing.subpages.impressum.prose.h2_contact') }}</h2>
      <p>
        Für Fragen, Hilfestellung oder Interesse an einer Partnerschaft:<br />
        E-Mail: <a href="mailto:support@viluu.de">support@viluu.de</a>
      </p>

      <h2>{{ trans.get('landing.subpages.impressum.prose.h2_register') }}</h2>
      <p>
        Eintragung im Handelsregister<br />
        Registergericht: Amtsgericht Charlottenburg<br />
        Registernummer: HRB 223337 B
      </p>

      <h2>{{ trans.get('landing.subpages.impressum.prose.h2_vat') }}</h2>
      <p>
        Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
        <strong>DE330060069</strong>
      </p>

      <h2>{{ trans.get('landing.subpages.impressum.prose.h2_liability') }}</h2>
      <p>
        Mit Urteil vom 12. Mai 1998 – 312 O 85/98 – „Haftung für Links" hat das Landgericht Hamburg
        entschieden, dass man durch die Anbringung eines Links die Inhalte der gelinkten Seite ggf.
        mit zu verantworten hat. Dies kann nur dadurch verhindert werden, dass man sich ausdrücklich
        von diesen Inhalten distanziert. Hiermit distanzieren wir uns ausdrücklich von allen
        Inhalten aller gelinkten Seiten auf unserer Internetpräsenz und machen uns diese Inhalte
        nicht zu Eigen. Diese Erklärung gilt für alle auf unserer Internetpräsenz publizierten Links
        und für alle Inhalte der Seiten, zu denen die bei uns veröffentlichten Banner und Links
        führen.
      </p>
      <p>
        Der Service enthält Links zu anderen Internet-Sites, Ressourcen und Mitgliedern dieses
        Service. Wir sind nicht verantwortlich für die Verfügbarkeit dieser externen Ressourcen oder
        deren Inhalte, die wir darüber hinaus nicht notwendigerweise billigen. Wir sind nicht für
        den Inhalt von Werbung, Produkten oder anderen Materialien auf diesen Sites verantwortlich.
      </p>
      <p>
        Unter keinen Umständen sind wir für Verluste oder Schaden, der angeblich durch die
        Verwendung oder den Verlass auf den Inhalt, die Güter oder Services dieser Sites entsteht,
        direkt oder indirekt verantwortlich oder haftbar. Alle Anliegen hinsichtlich eines externen
        Links sollten an den jeweiligen Site-Verwalter oder Webmaster gerichtet werden.
      </p>
      <p>
        Von etwaigen illegalen, persönlichkeitsverletzenden, moralisch oder ethisch anstößigen
        Inhalten distanzieren wir uns in aller Deutlichkeit. Bitte informieren Sie uns, wenn wir auf
        ein solches Angebot linken sollten.
      </p>

      <h2>{{ trans.get('landing.subpages.impressum.prose.h2_copyright') }}</h2>
      <p>
        Alle Rechte, insbesondere das Recht der Vervielfältigung und Verbreitung sowie der
        Übersetzung, sind vorbehalten. Kein Teil des Werks darf in irgendeiner Form (durch
        Fotokopie, Mikrofilm oder ein anderes Verfahren) ohne schriftliche Genehmigung der Autoren
        reproduziert oder unter Verwendung elektronischer Medien verarbeitet, vervielfältigt oder
        verbreitet werden.
      </p>

      <h2>{{ trans.get('landing.subpages.impressum.prose.h2_eu_dispute') }}</h2>
      <p>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
        <a
          href="https://ec.europa.eu/consumers/odr"
          target="_blank"
          rel="noopener"
        >
          https://ec.europa.eu/consumers/odr
        </a>.
        Unsere E-Mail-Adresse finden Sie oben im Impressum.
      </p>

      <h2>{{ trans.get('landing.subpages.impressum.prose.h2_consumer_dispute') }}</h2>
      <p>
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>

      <p class="impressum-source">Quelle: e-recht24.de</p>
    </main>
  </SubpageShell>
</template>

<script>
import SubpageShell from './SubpageShell.vue';

export default {
  name: 'ImpressumPage',
  components: { SubpageShell },
};
</script>
